import createLucideIcon from '../createLucideIcon';

const ChevronRightSquare = createLucideIcon('ChevronRightSquare', [
  [
    'rect',
    {
      width: '18',
      height: '18',
      x: '3',
      y: '3',
      rx: '2',
      ry: '2',
      key: '1m3agn',
    },
  ],
  ['polyline', { points: '10,8 14,12 10,16', key: '1m0o8b' }],
]);

export default ChevronRightSquare;
